// import React, { useEffect, useState } from "react";
// import ReactGA from "react-ga";
// import "./index.css";
// import Navbar from "./components/navbar.js";
// import Footer from "./components/footer.js";
// import Home from "./components/index.js";
// import ChiSiamo from "./components/chi-siamo.js";
// import NuovaOrchestra from "./components/nuova-orchestra.js";
// // import WindEnsemble from "./components/wind-ensemble.js";
// import SuonaConNoi from "./components/suona-con-noi.js";
// import Concerti from "./components/concerti.js";
// // import Galleria from "./components/galleria.js";
// import Contatti from "./components/contatti.js";
// import Partners from "./components/partners.js";
// import Privacy from "./components/privacy.js";
// import CinqueXmille from "./components/5x1000.js";
// import MilarteFaScuola from "./components/MilarteFaScuola.js";
// import NewGallery from "./components/newGallery.js";
// import NavbarDesktop from "./components/navbar.js";
// import NavbarMobile from "./components/navbarMobile.js";

// const TRACKING_ID = "G-YD95GEW4S8";
// ReactGA.initialize(TRACKING_ID);

// const App = () => {
//   const [currentSection, setCurrentSection] = useState("home");

//   useEffect(() => {
//     const handleHashChange = () => {
//       setCurrentSection(window.location.hash.substring(1) || "home");
//       ReactGA.pageview(window.location.pathname + window.location.hash);
//     };

//     window.addEventListener("hashchange", handleHashChange);
//     handleHashChange();

//     return () => {
//       window.removeEventListener("hashchange", handleHashChange);
//     };
//   }, []);

//   const renderSection = () => {
//     switch (currentSection) {
//       case "home":
//         return <Home />;
//       case "chi-siamo":
//         return <ChiSiamo />;
//       case "nuova-orchestra":
//         return <NuovaOrchestra />;
//       // case "wind-ensemble":
//       //   return <WindEnsemble />;
//       case "suona-con-noi":
//         return <SuonaConNoi />;
//       case "concerti":
//         return <Concerti />;
//       // case "galleria":
//       //   return <Galleria />;
//       case "contatti":
//         return <Contatti />;
//       case "partners":
//         return <Partners />;
//       case "privacy":
//         return <Privacy />;
//       case "5x1000":
//         return <CinqueXmille />;
//       case "Milarte-Fa-Scuola":
//         return <MilarteFaScuola />;
//       case "NewGallery":
//         return <NewGallery />;
//       default:
//         return <Home />;
//     }
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       {/* <Navbar /> */}
//       <div className="block xl:hidden">
//         <NavbarMobile />
//       </div>
//       <div className="hidden xl:block">
//         <NavbarDesktop /> {/* La tua navbar attuale */}
//       </div>
//       <main className="flex-grow font-light">{renderSection()}</main>
//       <Footer />
//     </div>
//   );
// };

// export default App;

import React, { useEffect, useState } from "react";
import ReactGA from "react-ga";
import "./index.css";

import Footer from "./components/footer.js";
import Home from "./components/index.js";
import ChiSiamo from "./components/chi-siamo.js";
import NuovaOrchestra from "./components/nuova-orchestra.js";
import SuonaConNoi from "./components/suona-con-noi.js";
import Concerti from "./components/concerti.js";
import Contatti from "./components/contatti.js";
import Partners from "./components/partners.js";
import Privacy from "./components/privacy.js";
import CinqueXmille from "./components/5x1000.js";
import MilarteFaScuola from "./components/MilarteFaScuola.js";
import NewGallery from "./components/newGallery.js";

import NavbarDesktop from "./components/navbar.js";
import NavbarMobile from "./components/navbarMobile.js";

const TRACKING_ID = "G-YD95GEW4S8";

ReactGA.initialize(TRACKING_ID);

const App = () => {
  const [currentSection, setCurrentSection] = useState("home");

  /* -------------------------------------------------------------- */
  /* Gestione cambio sezione                                        */
  /* -------------------------------------------------------------- */

  useEffect(() => {
    const handleHashChange = () => {
      const section =
        window.location.hash.substring(1) || "home";

      setCurrentSection(section);

      ReactGA.pageview(
        window.location.pathname + window.location.hash
      );
    };

    handleHashChange();

    window.addEventListener(
      "hashchange",
      handleHashChange
    );

    return () => {
      window.removeEventListener(
        "hashchange",
        handleHashChange
      );
    };
  }, []);

  /* -------------------------------------------------------------- */
  /* Riporta SEMPRE la nuova pagina in cima                         */
  /* -------------------------------------------------------------- */

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [currentSection]);

  /* -------------------------------------------------------------- */
  /* Render della sezione                                           */
  /* -------------------------------------------------------------- */

  const renderSection = () => {
    switch (currentSection) {
      case "home":
        return <Home />;

      case "chi-siamo":
        return <ChiSiamo />;

      case "nuova-orchestra":
        return <NuovaOrchestra />;

      case "suona-con-noi":
        return <SuonaConNoi />;

      case "concerti":
        return <Concerti />;

      case "contatti":
        return <Contatti />;

      case "partners":
        return <Partners />;

      case "privacy":
        return <Privacy />;

      case "5x1000":
        return <CinqueXmille />;

      case "Milarte-Fa-Scuola":
        return <MilarteFaScuola />;

      case "NewGallery":
        return <NewGallery />;

      default:
        return <Home />;
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Navbar mobile */}
      <div className="block xl:hidden">
        <NavbarMobile />
      </div>

      {/* Navbar desktop */}
      <div className="hidden xl:block">
        <NavbarDesktop />
      </div>

      <main className="flex-grow font-light">
        {renderSection()}
      </main>

      <Footer />
    </div>
  );
};

export default App;
